import React from 'react';
import { useTheme } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';

import { Flex } from '@ui-library/flex';
import { FlexCard } from '@ui-library/card';
import { BaseText, LargeText } from '@ui-library/typography';

interface AccountManagementBaseProps {
  loading: boolean;
  title?: string;
}

export const AccountManagementBase: React.FC<AccountManagementBaseProps> = ({
  loading,
  title,
  children,
}) => {
  const theme = useTheme();

  return (
    <Flex flexDirection="column" gap="0.25rem">
      {title && (
        <Flex alignItemsCenter gap="0.25rem">
          <FontAwesomeIcon icon={regular('cloud')} color={theme.token.colorLink} />
          <BaseText fontWeight={600}>{title}</BaseText>
        </Flex>
      )}

      <FlexCard borderColor={theme.token.colorBorderSecondary} flexDirection="row" alignItemsCenter>
        {loading ? (
          <Flex gap="0.5rem" alignItemsCenter>
            <FontAwesomeIcon
              icon={regular('circle-notch')}
              color={theme.token.colorPrimaryBase}
              spin
            />
            <LargeText strong>Loading accounts...</LargeText>
          </Flex>
        ) : (
          children
        )}
      </FlexCard>
    </Flex>
  );
};
